import { render, staticRenderFns } from "./flexiblePost.vue?vue&type=template&id=0dc41726&scoped=true"
import script from "./flexiblePost.vue?vue&type=script&lang=js"
export * from "./flexiblePost.vue?vue&type=script&lang=js"
import style0 from "./flexiblePost.vue?vue&type=style&index=0&id=0dc41726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc41726",
  null
  
)

export default component.exports